import clsx from 'clsx';
import styles from './Disclaimer.module.scss';

interface DisclaimerProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  tone?: 'default' | 'text';
}

export const Disclaimer = ({ id, children, className, tone = 'default' }: DisclaimerProps) => (
  <p
    className={clsx(styles.disclaimer, className, {
      [styles.toneText]: tone === 'text',
    })}
    id={id}
  >
    {children}
  </p>
);
